import React from 'react';
import '../styles/HomePage.css'; // Specific homepage styling

function HomePage() {
  return (
    <div className="homepage">
      <div className="logo-container">
        <img src="/chandra-industries.webp" alt="Chandra Industries Logo" className="logo" />
      </div>
      <div className="chat-link">
        <a href="mailto:me@chandraindustries.org">Lets chat.</a>
      </div>
    </div>
  );
}

export default HomePage;